module.exports = __webpack_public_path__ + "img/youtubeBlock.a6008ab0.png";